const dataTableFormMap = {};

function dynamicTitle ( title, params=false ) {
    let dynamicTitle = title
    
    if ( params ) {
        if ( params.mid ) {
            const module_chunks = params.mid.split('-')
            const module_text = capitalizeFirstWord( module_chunks.join(' '), 'each')            
            dynamicTitle = `${title} ${module_text}`
        } else if ( params.lid ) {
            dynamicTitle = `${title} ${params.lid}`
        }
    }

    return dynamicTitle;
}

function dateString () {
    const d         = new Date()
    const year      = String(d.getFullYear())
    const month     = String(d.getMonth()+1).padStart(2, '0')
    const day       = String(d.getDate()).padStart(2, '0')
    const secs      = String(d.getSeconds())

    return year.concat('', month.concat('', day.concat('', secs)))
}

function formatText (text, modelData) {
    return text && text.replace(/\$\{(.+)\}/g, (...args) => {
        const value = args[1];

        return modelData[value];
    });
}

function addBusinessDays (daysToAdd) {
    const currentDate = new Date();

    for (let i = 1; i <= daysToAdd; i++) {
        currentDate.setDate(currentDate.getDate() + 1);
        if (currentDate.getDay() === 6) {
            currentDate.setDate(currentDate.getDate() + 2);
        } else if (currentDate.getDay() === 0) {
            currentDate.setDate(currentDate.getDate() + 1);
        }
    }
    
    const calcDate = currentDate.toISOString().substring(0,10)+' 00:00:00'
    return calcDate
}

function addCalendarDays (daysToAdd) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + daysToAdd);
    
    const calcDate = currentDate.toISOString().substring(0,10)+' 00:00:00'
    return calcDate
}

function capitalizeFirstWord ( string, words_to_capitalize ) {
    let capitalized

    if ( words_to_capitalize == 'each' ) {
        const arr = string.split(" ");

        //loop through each element of the array and capitalize the first letter.
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }

        //Join all the elements of the array back into a string 
        //using a blankspace as a separator 
        capitalized = arr.join(" ");
    
    } else if ( words_to_capitalize == 'first' ) {
        capitalized = string.charAt(0).toUpperCase() + string.slice(1);
    }

    return capitalized
}

function checkProperties ( obj ) {
    for (var key in obj) {
        if (obj[key] !== null && obj[key] != "")
            return false;
    }
    return true;
}

function toFloat (originalValue) {
    let endValue = originalValue;

    if (typeof originalValue !== 'number') {
        const formattedValue = originalValue && originalValue.replace && originalValue.replace(/,/g, '')

        endValue = parseFloat(formattedValue);

        if (isNaN(endValue) || typeof endValue !== 'number') {
            console.warn(`Expected a number, recieved ${originalValue}`);

            endValue = 0;
        }
    }

    return endValue;
};

function is_Even (value) {
    return value % 2 === 0;
}

function toPercent (value) {
    const floatValue = toFloat(value);

    return `${floatValue.toFixed(2)}%`;
}

function toDollars (value) {
    const floatValue = toFloat(value);

    return floatValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function toDollarsListings (value) {
    const floatValue = toFloat(value);

    return `$${floatValue.toLocaleString()}`;
}

function addDataTableForm (data) {
    function addToMap (name, form) {
        if (dataTableFormMap[name]) {
            console.log(`${name} has already been mapped to the Data Table`);
            return;
        }

        dataTableFormMap[name] = form;
    }

    for (let key in data) {
        addToMap(key, data[key]);
    }
}

function getDataTableForm (name) {
    return dataTableFormMap[name];
}

function checkVisibility (data) {
    // item is our question
    // model is our form data
    const { item = {}, model } = data;
    const { dependencies } = item;

    function checkVisible(dependencies) {
        if (dependencies) {
            const depCheckFunction = dependencies.operator === 'or' ? Array.prototype.some : Array.prototype.every;

            return depCheckFunction.call(dependencies.items, (thisDep) => {
                // Call recursively to allow nested logic in the dependencies
                if (thisDep.items) {
                    const isVisible = checkVisible(thisDep);

                    return isVisible;
                }

                const value = thisDep.value;
                const name = thisDep.name;
                const operator = thisDep.operator || 'equal';
                const modelValue = model[name];
                // const { value, name, operator = 'equal'} = thisDep;

                switch (operator) {
                case 'equal':
                    // Loose equality is used intentionally to allow for type coercion
                    // Model values can be either numbers or strings
                    return modelValue == value;
                case 'notEqual':
                    // Loose equality is used intentionally to allow for type coercion
                    // Model values can be either numbers or strings
                    return modelValue != value;
                case 'greaterThan':
                    return modelValue >= value;
                case 'lessThan':
                    return modelValue < value;
                case 'isDefined':
                    return typeof modelValue !== 'undefined';
                case 'contains':
                    /**
                     * Checks truthiness of a value on an object
                     * Useful for checkboxes which are two objects deep
                     *
                     *  model = {
                     *      checkbox: {
                     *          val1: true,
                     *          val2: false
                     *      }
                     *  };
                     */

                    const subValue = modelValue || {};
                    return !!subValue[value];
                case 'in':
                    // if (!Array.isArray(value)) {
                    //     throw new Error('value must be an array to use the "in" operator');
                    // }
                    // return value.includes(model[name])
                    const answerArray = modelValue;

                    if (!Array.isArray(answerArray)) {
                        return false;
                    }
                    return answerArray.includes(value);
                case 'notIn':
                    // if (!Array.isArray(value)) {
                    //     throw new Error('value must be an array to use the "in" operator');
                    // }
                    // return value.includes(model[name])
                    const valueArray = modelValue;

                    if (!Array.isArray(valueArray)) {
                        return false;
                    }
                    return !valueArray.includes(value);
                }
            });
        } else {
            return true;
        }
    }

    const isVisible = checkVisible(dependencies);

    // log the visibility of the item if in dev mode
    devLog(`Visibility Check: ${item.name} is ${isVisible}`, data);

    return isVisible;
}

function devLog (...messages) {
    // How to enable dev mode:
    // localStorage.setItem('mode', 'dev');
    if (localStorage && localStorage.getItem('mode') === 'dev') {
        console.log(...messages);
    }
}

function generateGUID() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

function numberToWord( number ) {
    const units = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 
             'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];

    return units[number]
}

function mapFromSection(sectionData = {}) {
    // This is a little crazy because attributes can be nested for inline types or those with subItems
    // This will return a flattened object with item name as a key and the item as the value
    // Since it is an object, order cannot be assumed
    const { items = [] } = sectionData;

    function flattenData (map, itemArray) {
        return itemArray.reduce((memo, thisValuationItem) => {
            const { name, type, items, subItems } = thisValuationItem;

            if ( name ) {
                memo[name] = thisValuationItem;
            } else {
                const guid = generateGUID();

                memo[guid] = thisValuationItem;
            }

            if (type === 'inline') {
                // inline type items have nested items in the `items` property
                flattenData(memo, items);
            }

            if (subItems) {
                // subItems are nested in the `subItems` property
                flattenData(memo, subItems);
            }

            return memo;
        }, map);
    }

    return flattenData({}, items);
}

function removeProperties(obj, allowedProperties) {
    if (typeof obj !== 'object' || obj === null) {
        return obj; // Return non-object values as is
    }
  
    if (Array.isArray(obj)) {
        // If it's an array, iterate over each element and remove properties recursively
        return obj.map(item => removeProperties(item, allowedProperties));
    }
  
    const newObj = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (allowedProperties.includes(key)) {
                // If the property is in the allowed list, copy it to the new object
                newObj[key] = removeProperties(obj[key], allowedProperties);
            }
        }
    }
  
    return newObj;
}  

export {
    addBusinessDays,
    addCalendarDays,
    addDataTableForm,
    capitalizeFirstWord,
    checkProperties,
    checkVisibility,
    dateString,
    devLog,
    dynamicTitle,
    formatText,
    generateGUID,
    getDataTableForm,
    is_Even,
    mapFromSection,
    numberToWord,
    toDollars,
    toDollarsListings,
    toFloat,
    toPercent,
    removeProperties
};


// WEBPACK FOOTER //
// ./src/components/utilities.js